// The use case context in which AI is receiving and generating messages
export var AIMessageContext;
(function (AIMessageContext) {
    AIMessageContext["HOME_PAGE"] = "home_page";
    AIMessageContext["OTHERS"] = "others";
    // Additional contexts can be added as needed
    AIMessageContext["SQL_AUDIENCE"] = "sql_audience";
    AIMessageContext["VISUAL_AUDIENCE"] = "visual_audience";
    AIMessageContext["EVENT_SETUP"] = "events";
    AIMessageContext["SCHEMA_SEARCH"] = "schema_search";
    AIMessageContext["CHART"] = "chart";
    AIMessageContext["CUSTOM_ATTRIBUTE"] = "custom_attribute";
    AIMessageContext["CUSTOM_ATTRIBUTE_CREATION"] = "custom_attribute_creation";
    AIMessageContext["RELATIONS"] = "relations";
    AIMessageContext["INTERRUPT"] = "interrupt";
    AIMessageContext["ANALYTICS"] = "analytics";
})(AIMessageContext || (AIMessageContext = {}));
export var AiMessageTypes;
(function (AiMessageTypes) {
    AiMessageTypes["TEXT"] = "text";
    AiMessageTypes["IMAGE"] = "image";
    AiMessageTypes["JSON"] = "json";
    AiMessageTypes["TABLE_JSON"] = "table_json";
    AiMessageTypes["CHART"] = "chart";
    AiMessageTypes["ERROR"] = "error";
    AiMessageTypes["MEMORY_EXTRACTED"] = "memory_extracted";
    AiMessageTypes["MEMORY_REFERENCED"] = "memory_referenced";
    AiMessageTypes["FEEDBACK"] = "feedback";
})(AiMessageTypes || (AiMessageTypes = {}));
export var Author;
(function (Author) {
    Author["USER"] = "user";
    Author["SYSTEM"] = "system";
})(Author || (Author = {}));
export var FeedbackAuthor;
(function (FeedbackAuthor) {
    FeedbackAuthor["AI"] = "ai";
    FeedbackAuthor["USER"] = "user";
})(FeedbackAuthor || (FeedbackAuthor = {}));
// Constants
export const DEFAULT_THREAD_NAME = 'New chat';
export const feedbackRequiredMessageTypes = [
    AiMessageTypes.JSON,
    AiMessageTypes.TABLE_JSON,
];
export var AiEntityType;
(function (AiEntityType) {
    AiEntityType["WAREHOUSE"] = "warehouse";
    AiEntityType["CHANNEL"] = "channel";
})(AiEntityType || (AiEntityType = {}));
//# sourceMappingURL=ai.js.map